import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { AlertController } from '@ionic/angular';
// import { environment } from 'src/environments/environment';
import { environment } from '../../environments/environment';
import { RemoteConfig, fetchAndActivate, fetchConfig, getString } from '@angular/fire/remote-config';

import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

@Injectable({
	providedIn: 'root'
})
export class UpdateVersionService {
	isLoading: boolean = false;


	public currentAppVersion: any = environment['app_version'];

	setCurrentTime:any;
	dayTimeDiff:any;
	dailyResetTime:any;

	fireBaseArray:any[] = []
	constructor(public loadingController: LoadingController, public alertController: AlertController,
		private remoteConfig: RemoteConfig,
		 private alertCtrl: AlertController) { 
			this.remoteConfig.settings.minimumFetchIntervalMillis = 3600000;
		 }

  async checkForUpdate() {
    if (Capacitor.getPlatform() === 'web') {
     return;
    }
   await fetchAndActivate(this.remoteConfig);
	const forceUpgradeStr = JSON.parse(getString(this.remoteConfig, 'forceUpgrade'));
    const updateUrlAndroid = getString(this.remoteConfig, 'https://play.google.com/store/apps/details?id=com.iifl.iiflaaa');
    const updateUrlIOS = getString(this.remoteConfig, 'https://apps.apple.com/us/app/aaa-advisor-anytime-anywhere/id1563765662');
	 const currentVersion = App.getInfo().then(info => info.version);
    const current = (await currentVersion).toString();
	for(let item of forceUpgradeStr.versions){
		if (
		  current === item.version && item.forceUpgrade
		) {
				console.log('update required')
				// this.showUpdateAlert(updateUrlAndroid, updateUrlIOS);
				break;
		}
	}
  }

  private async showUpdateAlert(androidUrl: string, iosUrl: string) {
    const alert = await this.alertCtrl.create({
      header: 'Update Required',
      message: 'A new version of the app is available. Please update to continue.',
      backdropDismiss: false,
      buttons: [
        {
          text: 'Update Now',
          handler: () => {
            const platform = (navigator.userAgent.toLowerCase().includes('android')) ? androidUrl : iosUrl;
            window.open(platform, '_system');
            if (Capacitor.getPlatform() !== 'web') {
              App.exitApp(); // optional: close app after redirect
            }
          }
        }
      ]
    });
    await alert.present();
  }
}

